export const environment = {
  production: true,
  API_URL: 'https://backend.meteomanager.meteosol.de' + '/api',
  keycloak: {
    url: 'https://keycloak.meteomanager.meteosol.de' + '/auth',
    realm: 'meteosol-admin-realm',
    clientId: 'meteosol-admin-client',
  },
  auth: {
    use_dummy_auth: false,
  },
};
